import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import ReactRouterLink from "./ReactRouterLink";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { fetchCategories } from "../../redux/actions/categoryAction";
import { SubCategory } from "../../redux/types/categoryTypes";

const Loader: React.FC = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "50px",
      marginBottom: "20px",
    }}
  >
    <CircularProgress color="primary" />
  </div>
);

const CategoryMenu: React.FC = () => {
  const [openCategory, setOpenCategory] = useState<string | null>(null);
  const dispatch = useDispatch();
  const { loading, categoriesData } = useSelector(
    (state: RootState) => state.categories
  );

  useEffect(() => {
    dispatch(fetchCategories());
  }, []);

  const isDesktop = window.innerWidth >= 768;

  const handleCategoryClick = (categorySerial: string) => {
    setOpenCategory((prevOpenCategory) =>
      prevOpenCategory === categorySerial ? null : categorySerial
    );
  };

  return (
    <div
      style={{
        maxHeight: isDesktop ? "400px" : "auto",
        overflowY: isDesktop ? "auto" : "visible",
      }}
    >
      <h2 className="modalTitle" style={{ textAlign: "center" }}>
        All Categories
      </h2>

      {loading && <Loader />}

      {!loading && !categoriesData.categories.length && (
        <p>No categories found.</p>
      )}

      {!loading && categoriesData.categories.length > 0 && (
        <List>
          {categoriesData.categories.map((category) => (
            <React.Fragment key={category.id}>
              <ListItemButton>
                <ReactRouterLink
                  style={{
                    color: "black",
                  }}
                  to={`/${category.slug}`}
                  linkElement={<ListItemText primary={category.name} />}
                  isLinkUnderline={false}
                />
                {category.subcategories &&
                  category.subcategories.length > 0 &&
                  openCategory === category.serial && (
                    <ExpandLess
                      onClick={() => handleCategoryClick(category.serial)}
                    />
                  )}
                {category.subcategories &&
                  category.subcategories.length > 0 &&
                  openCategory !== category.serial && (
                    <ExpandMore
                      onClick={() => handleCategoryClick(category.serial)}
                    />
                  )}
              </ListItemButton>

              {category.subcategories && (
                <Collapse
                  in={openCategory === category.serial}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {category.subcategories.map((subcategory: SubCategory) => (
                      <ReactRouterLink
                        style={{
                          color: "black",
                        }}
                        to={`/${category.slug}/${subcategory.slug}`}
                        linkElement={
                          <ListItemButton key={subcategory.id} sx={{ pl: 4 }}>
                            <ListItemText primary={subcategory.name} />
                          </ListItemButton>
                        }
                        isLinkUnderline={false}
                      />
                    ))}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          ))}
        </List>
      )}
    </div>
  );
};

export default CategoryMenu;
